module.exports = __webpack_public_path__ + "static/media/microsoft.98a41061.jpg";